export default __webpack_public_path__ + "static/media/352.a2a780b4.gif";